<template>
	<!-- 发型师流失 -->
	<div style="father">
		<div style="margin-bottom: 15px;">
			<el-date-picker v-model="time" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"  @change="getStoreData()">
			</el-date-picker>
			<el-button @click="getStoreData()" style="margin-left: 10px;" type="primary" size="small">筛选</el-button>
			<el-button @click="expor()" style="margin-left: 10px;" type="primary" size="small">导出</el-button>
		</div>
		<div style="text-align: center;">
			<el-table style="text-align: center;" :cell-style="{'text-align': 'center'}" :data="tableData"
				v-loading="loading"
				:header-cell-style="{'text-align': 'center','color':'#6f6f6f', 'border-color': '#dfdfdf'}">
				<el-table-column prop="time" label="日期"></el-table-column>
				<el-table-column prop="workerName" label="发型师"></el-table-column>
				<el-table-column prop="dropoutUser" label="流失用户数"></el-table-column>
				<el-table-column prop="userRate" label="流失率" sortable>
					<template slot-scope="scope">
						{{scope.row.userRate?Math.round(scope.row.userRate*100):0}}%
					</template>
				</el-table-column>
				<el-table-column prop="dropoutNew" label="新客流失">
					<template slot-scope="scope">
						{{scope.row.dropoutNew?scope.row.dropoutNew:"/"}}
					</template>
				</el-table-column>
				<el-table-column prop="newRate" label="新客流失率" sortable>
					<template slot-scope="scope">
						{{scope.row.newRate?Math.round(scope.row.newRate*100):0}}%
					</template>
				</el-table-column>
				<el-table-column prop="dropoutOld" label="老客流失">
					<template slot-scope="scope">
						{{scope.row.dropoutOld?scope.row.dropoutOld:"/"}}					</template>
				</el-table-column>
				<el-table-column prop="oldRate" label="老客流失率" sortable>
					<template slot-scope="scope">
						{{scope.row.oldRate?Math.round(scope.row.oldRate*100):0}}%
					</template>
				</el-table-column>
				<el-table-column prop="cutTotal" label="剪发总数"></el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import {
		url
	} from '../../../utils/index.js'
	import {
		export2Excel
	} from '../../../common/js/util'
	export default {
		data() {
			return {
				url: url(),
				loading:false,
				time: new Date().getFullYear() + '-' +
					((new Date().getMonth() + 1) > 9 ? (new Date().getMonth() + 1) : ('0' + (new Date().getMonth() + 1))) +
					'-' +
					(new Date().getDate() > 9 ? new Date().getDate() : ('0' + new Date().getDate())),
				tableData: [],
				columns: [{
					title: '日期',
					key: 'time'
				}, {
					title: '发型师',
					key: 'workerName'
				}, {
					title: '流失用户数',
					key: 'dropoutUser'
				}, {
					title: '流失率',
					key: 'userRate'
				}, {
					title: '新客流失',
					key: 'dropoutNew'
				}, {
					title: '新客流失率',
					key: 'newRate'
				}, {
					title: '老客流失',
					key: 'dropoutOld'
				}, {
					title: '老客流失率',
					key: 'oldRate'
				}, {
					title: '剪发总数',
					key: 'cutTotal'
				}]
			};
		},
		mounted() {
			this.getStoreData()
		},
		methods: {
			getStoreData() {
				this.loading = true;
				var a = "?time=" + this.time
				this.$http.get("dOrder/workerDropout" + a).then(res => {
					this.tableData = res.body.data
					this.tableData.map(ele=>{
						ele.userRate = ele.userRate/100
						ele.newRate =  ele.newRate/100
						ele.oldRate =  ele.oldRate/100
					})
					this.loading = false
				})
			},
			// 导出
			expor() {
				var a = this.tableData
				export2Excel(this.columns, a)
			},
		}
	}
</script>

<style>
	.el-table__footer-wrapper tbody td,
	.el-table__header-wrapper tbody td {
		text-align: center;
	}
</style>